import { Outlet, createFileRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { Header } from './$id/-header/-components';
import { usePublicIdHeader } from './$id/-header/-hooks/usePublicIdHeader';
import { usePublicIdSubtypeLabel } from './$id/-header/-hooks/usePublicIdSubtypeLabel';
export const Route = createFileRoute('/_staff/public-ids/$id')({
  component: PublicIdDetailLayout
});
function PublicIdDetailLayout() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.publicIds'
  });
  const {
    id
  } = Route.useParams();
  const {
    data
  } = usePublicIdHeader(id);
  const subtypeLabel = usePublicIdSubtypeLabel();
  const subtype = data?.publicId?.subtype;
  useDocumentTitle(subtype ? `${t('detail.pageTitle')} - ${subtypeLabel(subtype)}` : t('detail.pageTitle'));
  return <VStack>
      <Header />
      <Outlet />
    </VStack>;
}